import { render, staticRenderFns } from "./VNCView.vue?vue&type=template&id=4adcf520&scoped=true"
import script from "./VNCView.vue?vue&type=script&lang=js"
export * from "./VNCView.vue?vue&type=script&lang=js"
import style0 from "./VNCView.vue?vue&type=style&index=0&id=4adcf520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcf520",
  null
  
)

export default component.exports